import gql from 'graphql-tag'

const offerte = gql`
  query offerte (
    $limit: Int!,
    $offset: Int,
    $where: OfferteFilterInput,
    $orderBy: [OfferteOrderBy]
  ) {
    offerte (
      limit: $limit,
      offset: $offset,
      where: $where,
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        id
        nome
        tipoOffertaId
        tipoOfferta {
          id
          tipo
        }
      }
    }
  }
`

export default offerte


// WEBPACK FOOTER //
// ./src/graphql/queries/offerte.js